import { HostProjectsTable } from '@/components/HostProjectsTable';

import { DEFAULT_PAGINATION_MODEL } from '../constants';

export function HomeHostsProjectsTable() {
  return (
    <HostProjectsTable
      simple={true}
      defaultPaginationModel={DEFAULT_PAGINATION_MODEL}
    />
  );
}
